import { ShopSort, ShopFilter } from '@data/sanity/schema'
import { Keyed } from '@lib/helpers'
import { SanityHasSlug } from './page'
import { SanityColor } from './product'

export enum SanityFilterType {
  SIMPLE = ' ',
  SWATCH = 'swatch',
}

export enum SanityFilterGroupDisplay {
  DEFAULT = ' ',
  GRID = 'grid',
}

export type SanityFilterGroupOption = SanityHasSlug & {
  type: SanityFilterType
  title: string
  color?: SanityColor
}

export type SanityFilterGroup = Keyed<
  SanityHasSlug & {
    display: SanityFilterGroupDisplay
    title: string
    options: Array<SanityFilterGroupOption>
  }
>

export type SanityFilter = Pick<ShopFilter, 'isActive'> & {
  groups?: Array<SanityFilterGroup>
}

export enum SanitySortOptionType {
  FEATURED = 'featured',
  ALPHA_ASCENDING = 'alphaAsc',
  ALPHA_DESCENDING = 'alphaDesc',
  DATE_ASCENDING = 'dateAsc',
  DATE_DESCENDING = 'dateDesc',
  PRICE_ASCENDING = 'priceAsc',
  PRICE_DESCENDING = 'priceDesc',
}

export type SanitySortOption = {
  type: SanitySortOptionType
  title: string
}

export type SanitySort = Pick<ShopSort, 'isActive'> & {
  options?: Array<SanitySortOption>
}
